import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Cell2Input } from "src/components/Sheet2/components";
import { Cell2 } from "src/components/Sheet2/Cell2";
import { t } from "i18next";
import { SelectBom2aMaterial } from "../../SelectBom2aMaterial";
import { Bom2aPositionsStore } from "../../../Bom2aPositionsStore";
import {
  Bom2aEdPosition,
  Bom2aEdPositionRow,
  bom2aUiSize,
  ZBom2aMaterialDesc,
} from "../../../Bom2aPositionsTypes";
import styles from "./Bom2aCellDescription.module.less";
import { assignBom2aDesc } from "../../../apiBom2aPositions";

type PropsBom2aCellDescription = {
  row: Bom2aEdPositionRow;
  bomPosition: Bom2aEdPosition | null;
  store: Bom2aPositionsStore;
  pos: Cell2["pos"];
};

const fieldKey = "Description";

export const Bom2aCellDescription: React.FC<PropsBom2aCellDescription> =
  observer((props) => {
    const { row, store, pos, bomPosition } = props;
    const [open, setOpen] = React.useState(false);

    const onChange = async (item: ZBom2aMaterialDesc) => {
      await store.updateTask(async () => {
        await assignBom2aDesc({
          bomPositionId: row.id,
          descriptionId: item.id,
        });
      });
    };

    if (!bomPosition) return <div>Empty BOM position</div>;
    return (
      <div className={styles.box}>
        <div className={styles.edit}>
          <Cell2Input
            cell={{
              cellKey: `${fieldKey}:${row.id}`,
              store: store.sheetStore,
              pos,
              emptyValue: "",
              value: row.fields.descriptionManualValue.value,
              save: async (value) => {
                await store.saveFieldValue(
                  row.id,
                  row.fields.descriptionManualValue.id,
                  value as string,
                );
                return () => {
                  store.updateFieldValue(
                    row.id,
                    "descriptionManualValue",
                    String(value),
                  );
                };
              },
            }}
            editorProps={{ allowClear: true, size: bom2aUiSize }}
          />
        </div>
        <Button
          icon={<PlusOutlined />}
          size={bom2aUiSize}
          type="text"
          onClick={() => setOpen(true)}
        />
        <SelectBom2aMaterial
          title={`${t("Material Type")}: ${bomPosition.materialTypeName}`}
          materialTypeId={bomPosition.materialTypeId}
          multi={false}
          open={open}
          close={() => setOpen(false)}
          exec={async (list) => {
            const item = list[0];
            if (item) {
              await onChange(item);
            }
          }}
        />
      </div>
    );
  });
